module.exports = __webpack_public_path__ + "static/media/burgerStatus.0d1f8ed5.svg";